import { RouteObject } from "react-router";
import { eftHashPath, eftPath } from "./constants/routes";
import CleComplianceApp from "./App";
import HomeView from "./views/home/HomeView";
import AuthorshipDocumentView from "./views/documents/AuthorshipDocumentView";
import CourseCertificateDocumentView from "./views/documents/CourseCertificateDocumentView";
import InsurancePolicyDocumentView from "./views/documents/InsurancePolicyDocumentView";
import ReductionDocumentView from "./views/documents/ReductionDocumentView";
import LegalAidDocumentView from "./views/documents/LegalAidDocumentView";
import DispensationDocumentView from "./views/documents/DispensationDocumentView";
import TeachingDocumentView from "./views/documents/TeachingDocumentView";
import IndberetningerView from "./views/indberetninger/IndberetningerView";
import IndberetningDetailView from "./views/indberetninger/IndberetningDetailView";
import AfgorelserView from "./views/afgorelser/AfgorelserView";
import AfgorelseDetailView from "./views/afgorelser/AfgorelseDetailView";
import SigneringDoneView from "./views/signering/SigneringDoneView";
import SigneringFailureView from "./views/signering/SigneringFailureView";

/** Efteruddannelse routes (CLE compliance), mounted at /efteruddannelse */
export const CleComplianceRoutes: RouteObject = {
  element: <CleComplianceApp />,
  children: [
    { index: true, element: <HomeView /> },
    {
      path: "dokumenter/kursusbevis/:id",
      element: <CourseCertificateDocumentView />,
      handle: {
        breadcrumbs: [
          { label: "Hjem", to: eftHashPath("course-certificates") },
          { label: "Kursusbevis" },
        ],
      },
    },
    {
      path: "dokumenter/forsikring/:id",
      element: <InsurancePolicyDocumentView />,
      handle: {
        breadcrumbs: [
          { label: "Hjem", to: eftHashPath("policies") },
          { label: "Forsikring" },
        ],
      },
    },
    {
      path: "dokumenter/reduktion/:id",
      element: <ReductionDocumentView />,
      handle: {
        breadcrumbs: [
          { label: "Hjem", to: eftHashPath("reductions") },
          { label: "Reduktion" },
        ],
      },
    },
    {
      path: "dokumenter/advokatvagt-retshjaelp/:id",
      element: <LegalAidDocumentView />,
      handle: {
        breadcrumbs: [
          { label: "Hjem", to: eftHashPath("legal-aid") },
          { label: "Advokatvagt/retshjælp" },
        ],
      },
    },
    {
      path: "dokumenter/dispensation/:id",
      element: <DispensationDocumentView />,
      handle: {
        breadcrumbs: [
          { label: "Hjem", to: eftHashPath("dispensations") },
          { label: "Dispensation" },
        ],
      },
    },
    {
      path: "dokumenter/undervisning/:id",
      element: <TeachingDocumentView />,
      handle: {
        breadcrumbs: [
          { label: "Hjem", to: eftHashPath("teachings") },
          { label: "Undervisning" },
        ],
      },
    },
    {
      path: "dokumenter/forfatterskab/:id",
      element: <AuthorshipDocumentView />,
      handle: {
        breadcrumbs: [
          { label: "Hjem", to: eftHashPath("authorships") },
          { label: "Forfatterskab" },
        ],
      },
    },
    {
      path: "indberetninger",
      element: <IndberetningerView />,
    },
    {
      path: "indberetninger/:id",
      element: <IndberetningDetailView />,
      handle: {
        breadcrumbs: [
          {
            label: "Indberetninger",
            to: eftPath("indberetninger"),
          },
          { label: "Indberetning" },
        ],
      },
    },
    {
      path: "afgorelser",
      element: <AfgorelserView />,
    },
    {
      path: "afgorelser/:type/:id",
      element: <AfgorelseDetailView />,
      handle: {
        breadcrumbs: [
          {
            label: "Afgørelser",
            to: eftPath("afgorelser"),
          },
          { label: "Afgørelse" },
        ],
      },
    },
    {
      path: "signering/done",
      element: <SigneringDoneView />,
      handle: {
        breadcrumbs: [{ label: "Signering" }],
      },
    },
    {
      path: "signering/failure",
      element: <SigneringFailureView />,
      handle: {
        breadcrumbs: [{ label: "Signering fejl" }],
      },
    },
  ],
};
